import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberEditTravelCoordinator {
	private travelCoordForm:any   = $('#member-add-travel-coordinator');
	private memberBase:any = new memberPortal();

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.travelCoordForm, function(validation: any) {
			// all your custom validation here

			// confirm email validation
			let emailId:string = 'add-travcord--personal-email';
			let confirmEmail:any = _self.travelCoordForm.find('#add-travcord--personal-email-confirm');
			confirmEmail.attr('data-parsley-equalto', '#'+emailId);

			//Alpha fields
			// MHCOMDIGI-581: remove alphanumeric validation from this field
			// #add-travcord--personal-address-line-1
			let alphaInputs = _self.travelCoordForm.find('#add-travcord--personal-address-city, #add-travcord--personal-address-state');
			alphaInputs.attr({
				'data-parsley-pattern': '^[a-zA-Z0-9 ]+$'
			});

			// Mobile number
			let mobileNumber = _self.travelCoordForm.find('#add-travcord--personal-phone--home, #add-travcord--personal-phone--mobile, #add-travcord--personal-phone--office, #add-travcord--personal-phone--fax');
			mobileNumber.each((i:number, el:any) => {
				$(el).attr({
					'data-parsley-type': 'number'
				});
			});
		},
		function(validation:any, formData:any) {
			// on success function
			let submitBtn = _self.travelCoordForm.find('#member-add-travel-coordinator-submit');
			let successMsg = $('#member-add-travel-coordinator-success');

				$('body').animate({
					'scrollTop': 0
				}, 500, () => {
					submitBtn.fadeOut();
					successMsg.fadeIn();
				});

		});
	}

}

let scope:Element = document.querySelector('#member-add-travel-coordinator');

if (scope) {
	try {
	let memberedittravelcoordinator = new memberEditTravelCoordinator();
	memberedittravelcoordinator.validateForm();
	} catch(e) {console.error(e);}
}
